export default "__VITE_ASSET__ZW15Asmz__"